import {ReactNode, useEffect} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/de'
import '@formatjs/intl-relativetimeformat/locale-data/es'
import '@formatjs/intl-relativetimeformat/locale-data/fr'
import '@formatjs/intl-relativetimeformat/locale-data/ja'
import '@formatjs/intl-relativetimeformat/locale-data/zh'

import deMessages from './messages/de.json'
import enMessages from './messages/en.json'
import esMessages from './messages/es.json'
import frMessages from './messages/fr.json'
import jaMessages from './messages/ja.json'
import zhMessages from './messages/zh.json'

const allMessages = {
  de: deMessages,
  en: enMessages,
  es: esMessages,
  fr: frMessages,
  ja: jaMessages,
  zh: zhMessages,
}

interface I18nProviderProps {
  children: ReactNode
}

const I18nProvider = ({children}: I18nProviderProps) => {
  const locale = useLang()
  const presentationLocale = locale === 'en' ? 'en-AU' : locale
  const messages = allMessages[locale]

  useEffect(() => {
    document.documentElement.lang = presentationLocale
  }, [presentationLocale])

  return (
    <IntlProvider locale={presentationLocale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
